import { Input } from '@wolfejs/ui/Input';
import { DetailsListView } from '../DetailsListView/DetailsListView';
import type { FundMode } from './types';

type DepositInfoModalProps = {
  fundMode: FundMode;
};

enum BankDetailsLables {
  accountName = 'Account Name',
  bankName = 'Bank Name',
  bankAddress = 'Bank Address',
  city = 'City/State/Zip',
  accountNumber = 'Account Number',
  routingNumber = 'Routing Number',
}

export const DepositInfoModal = ({ fundMode }: DepositInfoModalProps) => {
  const { bankDetails } = fundMode;
  const bankData = {
    accountName: bankDetails.accountName,
    bankName: bankDetails.bankName,
    bankAddress: bankDetails.bankAddress,
    accountNumber: bankDetails.accountNumber,
    routingNumber: bankDetails.routingNumber,
    city: `${bankDetails.city}, ${bankDetails.state} ${bankDetails.zip}`,
  };
  return (
    <div className="item-center flex w-full flex-col gap-8 px-5">
      <Input disabled value={fundMode.mode} />
      <div className="bg-default-400 border-b-default-700 flex justify-center border-b py-2">
        {`${fundMode.mode} (transfer fee $${fundMode.bankDetails.transferFee.toFixed(2)})`}
      </div>
      <div className="w-3/4">
        <DetailsListView data={bankData} labels={BankDetailsLables} divider={false} />
      </div>
      <p>Perfect Gift, LLC is a Wolfe property and operates as a custodial account for Wolfe Merchant Solutions clients.</p>
    </div>
  );
};
